export default __webpack_public_path__ + "static/Graphik-Light-Web-619af668170d5ec211b616601a9748bb.eot";